import { render, staticRenderFns } from "./move.vue?vue&type=template&id=618ce29c&scoped=true"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"
import style0 from "./move.vue?vue&type=style&index=0&id=618ce29c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ce29c",
  null
  
)

export default component.exports